  
const update = {
    data() { 
      return {  
        
        userupdateData: { 
          FirstName: "",
          LastName: "",
          AvatarUrl: "", 
          Email:"",
          }, 
          FormDataType:{
            FirstName:{FieldName:"FirstName",Field:"input",FieldTitle:this.$t('userupdate.AddEdit.FirstName'),FieldType:"text"},   
            LastName:{FieldName:"LastName",Field:"input",FieldTitle:this.$t('userupdate.AddEdit.LastName'),FieldType:"text"},   
            AvatarUrl:{FieldName:"AvatarUrl",Field:"input",FieldTitle:this.$t('userupdate.AddEdit.AvatarUrl'),FieldType:"text"},   
          } 
      }
    }, 
 
}
export default update